import useWiseOwlContext, {
  WiseOwlContext,
  WiseOwlProvider,
} from "./useWiseOwlContext";

export { WiseOwlContext, WiseOwlProvider };
export default useWiseOwlContext;
